export default function SignupSliderIco1() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9791 7.73893C25.296 6.88258 26.5072 6.88258 26.8241 7.73893L27.0935 8.46696C28.7539 12.9542 32.2918 16.492 36.779 18.1525L37.507 18.4219C38.3633 18.7387 38.3633 19.9499 37.507 20.2668L36.779 20.5362C32.2918 22.1966 28.7539 25.7345 27.0935 30.2217L26.8241 30.9497C26.5072 31.8061 25.296 31.8061 24.9791 30.9497L24.7097 30.2217C23.0493 25.7345 19.5114 22.1966 15.0242 20.5362L14.2962 20.2668C13.4398 19.9499 13.4398 18.7387 14.2962 18.4219L15.0242 18.1525C19.5114 16.492 23.0493 12.9542 24.7097 8.46696L24.9791 7.73893Z"
        fill="#D21A88"
      />
      <path
        d="M7.25387 25.9247C7.46512 25.3538 8.27259 25.3538 8.48384 25.9247L8.53408 26.0605C9.46083 28.5649 11.4355 30.5396 13.9399 31.4663L14.0757 31.5166C14.6466 31.7278 14.6466 32.5353 14.0757 32.7465L13.9399 32.7968C11.4355 33.7235 9.46083 35.6982 8.53408 38.2026L8.48384 38.3384C8.27258 38.9093 7.46512 38.9093 7.25387 38.3384L7.20362 38.2026C6.27688 35.6982 4.30225 33.7235 1.79776 32.7968L1.66197 32.7465C1.09107 32.5353 1.09107 31.7278 1.66197 31.5166L1.79776 31.4663C4.30225 30.5396 6.27688 28.5649 7.20362 26.0605L7.25387 25.9247Z"
        fill="#D21A88"
      />
      <path
        d="M10.0175 2.59746C10.1809 2.15586 10.8055 2.15586 10.9689 2.59746C11.5663 4.21186 12.8392 5.48471 14.4535 6.08209C14.8951 6.24549 14.8951 6.87009 14.4535 7.0335C12.8392 7.63088 11.5663 8.90373 10.9689 10.5181C10.8055 10.9597 10.1809 10.9597 10.0175 10.5181C9.42013 8.90373 8.14728 7.63088 6.53289 7.0335C6.09128 6.87009 6.09128 6.24549 6.53289 6.08209C8.14728 5.48471 9.42013 4.21186 10.0175 2.59746Z"
        fill="#D21A88"
      />
    </svg>
  );
}
